const Dropdown = ({ value, onChange, options }) => {
  return (
    <select
      name="dropdown"
      id="dropdown"
      className="dropdown"
      value={value || ""}
      onChange={onChange}
    >
      {options.map((option, index) => (
        <option key={index} value={option}>
          {option || "Find by a Region"}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
